import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import Topbar from "../../../components/Topbar";
import { useParams, useSearchParams } from "react-router-dom";
import Loader from "../../../components/Loader";
import PracticeMain from "../../../components/b2bCandidate/practice/PracticeMain";
import {
  getFreeGuideBasicDetailsApi,
  getGuideBasicDetailsApi,
} from "../../../api/candidate";
import WebUtils from "../../../utils/WebUtils";
import { ROLES } from "../../../constants/UserRoles";

function Practice() {
  const { jobGuideIdentifier } = useParams();
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");

  const [loading, setLoading] = useState(false);
  const [basicGuideDetails, setBasicGuideDetails] = useState(null);

  const getBasicGuideDetails = () => {
    let url = "";
    if (industryId) {
      url = `${getFreeGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    } else {
      url = `${getGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    }

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBasicGuideDetails(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobGuideIdentifier) getBasicGuideDetails();
  }, [jobGuideIdentifier]);

  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparation" userRole={ROLES.b2b_candidate} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparation"
            userRole={ROLES.b2b_candidate}
            newTitle={`Practice Guide (${
              basicGuideDetails?.jobTitle || "N/A"
            })`}
          />
          <div
            id="practice-container"
            className="py-[1.2rem] px-[0.8rem] lg:px-6 "
          >
            <PracticeMain />
          </div>
        </div>
      </div>
    </>
  );
}

export default Practice;
